var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackspace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.50016L9.16667 12.5002M9.16667 7.50016L14.1667 12.5002M2.26667 10.8002L5.86667 15.6002C6.16 15.9913 6.30667 16.1868 6.49254 16.3279C6.65717 16.4528 6.8436 16.546 7.04231 16.6028C7.26667 16.6668 7.51111 16.6668 8 16.6668H14.3333C15.7335 16.6668 16.4335 16.6668 16.9683 16.3943C17.4387 16.1547 17.8212 15.7722 18.0609 15.3018C18.3333 14.767 18.3333 14.067 18.3333 12.6668V7.3335C18.3333 5.93336 18.3333 5.2333 18.0609 4.69852C17.8212 4.22811 17.4387 3.84566 16.9683 3.60598C16.4335 3.3335 15.7335 3.3335 14.3333 3.3335H8C7.51111 3.3335 7.26667 3.3335 7.04231 3.39757C6.8436 3.45432 6.65717 3.54754 6.49254 3.67246C6.30667 3.8135 6.16 4.00905 5.86667 4.40016L2.26667 9.20016C2.05151 9.48704 1.94392 9.63049 1.90245 9.78802C1.86585 9.92708 1.86585 10.0732 1.90245 10.2123C1.94392 10.3698 2.05151 10.5133 2.26667 10.8002Z",
    stroke: "#11113A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.fba9faedc1ea501697ddfb19bc146184.svg";
export { ForwardRef as ReactComponent };